"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const testAddresses = [];
exports.testCustomer = {
    id: 'mockCtUserId',
    version: 1,
    createdAt: '',
    lastModifiedAt: '',
    email: '',
    password: '',
    addresses: testAddresses,
    isEmailVerified: true,
};
const testLineItems = [];
const testPrices = [];
exports.testOrder = {
    id: 'mockCtUserId',
    version: 1,
    createdAt: '',
    lineItems: testLineItems,
    totalPrice: {
        type: 'centPrecision',
        centAmount: 1000,
        fractionDigits: 2,
        currencyCode: 'USD',
    },
    shippingPrices: {
        weight: 1,
        prices: testPrices,
    },
    inventoryMode: '',
};
//# sourceMappingURL=commerce-types.js.map